const productsContainer = document.querySelector(".products");
const productsLoadingIndicator = document.querySelector(
  ".products-loading-indicator",
);
const productShims = Array.from(
  productsContainer.querySelectorAll(".product.shim"),
);

let isFetchingProducts = false;
let nextPage = parseInt(productsContainer.dataset.currentPage) + 1;
let hasMoreProducts = true;

initScrollListener();
initLoadMoreBtn();

function onProductsResize() {}

function layoutProducts(newProducts = []) {
  for (const product of newProducts) productsContainer.appendChild(product);
  for (const shim of productShims) productsContainer.appendChild(shim);
}

async function loadMoreProducts() {
  if (isFetchingProducts || !hasMoreProducts) return;
  isFetchingProducts = true;
  productsLoadingIndicator.classList.add("loading");
  const sectionId = productsContainer.classList.contains("lookbook")
    ? "lookbook-collection-products"
    : "collection-products";
  const pageParam = productsContainer.dataset.pageParam;
  const numberOfPages = parseInt(productsContainer.dataset.numberOfPages);
  console.info("data", productsContainer.dataset);
  const sortBy = productsContainer.dataset.sortBy; // sort_by%3Dtitle-ascending
  const url = `${location.href}?section_id=${sectionId}&${pageParam}=${nextPage}&sort_by=${sortBy}`;
  const response = await fetch(url);
  const div = document.createElement("div");
  div.innerHTML = await response.text();
  const newProducts = Array.from(div.querySelectorAll("a.product"));
  isFetchingProducts = false;
  nextPage++;
  hasMoreProducts = nextPage <= numberOfPages;
  productsLoadingIndicator.classList.remove("loading");
  layoutProducts(newProducts);
  onProductsResize();
}

async function initLoadMoreBtn() {
  const loadMoreBtn = document.querySelector(".load-more-products");
  loadMoreBtn.onclick = loadMoreProducts;
}

async function initScrollListener() {
  const checkForBottomOfPage = function () {
    if (
      window.innerHeight + window.scrollY + 100 >=
      document.body.offsetHeight
    ) {
      loadMoreProducts();
    }
  };
  checkForBottomOfPage();
  window.addEventListener("scroll", checkForBottomOfPage);
}
